import React from 'react';
import { View, Text } from 'react-native';
import type { ICurrentPathway } from 'app/types/pathway';
import { useAuth } from 'app/auth/hooks/useAuth';
import { useTranslation } from 'react-i18next';
import { getDoctorTitle } from '@shared/utils/doctor';

interface TreatmentCardProps {
  pathway?: ICurrentPathway;
}

export default function TreatmentCard({ pathway }: TreatmentCardProps) {
  const { meData } = useAuth();
  const { t } = useTranslation();
  const doctor = meData?.current_pathway?.doctor;
  const docTitle = getDoctorTitle(doctor?.title, t);

  const getTranslatedObjective = (): string => {
    if (pathway?.objective) {
      return pathway.objective;
    }
    return 'N/A';
  };

  return (
    <View className="bg-white rounded-xl mx-4 mb-2 mt-4 shadow-sm border border-gray-200">
      <View className="p-4 border-b border-gray-100">
        <View className="flex-row items-center">
          <Text className="text-xl font-bold text-black ">
            {pathway?.name || t('screens.profile.pathDetails.no-pathway')}
          </Text>
        </View>
      </View>

      <View className="p-4">
        <View className="flex-row justify-between items-center mb-4">
          <Text className="text-base font-medium text-gray-700">
            {t('screens.profile.pathDetails.doctor')}

          </Text>
          <Text className="text-base text-black font-medium">
            {`${docTitle} ${doctor?.last_name || 'N/A'}`}
          </Text>
        </View>

        <View className="flex-row justify-between items-center">
          <Text className="text-base font-medium text-gray-700">
            {t('screens.profile.pathDetails.objective')}
          </Text>
          <View className="bg-secondary-100 px-3 py-2 rounded-full border border-secondary-600">
            <Text className="text-secondary-600 text-sm font-bold">
              {getTranslatedObjective()}
            </Text>
          </View>
        </View>
      </View>
    </View>
  );
}
